/**
 * Store mínima do palette de busca global (Cmd+K) — story E3.2.1.
 *
 * Usa ``useSyncExternalStore`` (React 18) em vez de Zustand (não instalado neste
 * projeto) ou Context: o botão gatilho vive no ``<Header/>`` e o dialog em
 * ``<GlobalSearchBar/>`` — árvores irmãs. Uma store module-level desacopla os
 * dois sem precisar de provider e sem re-renderizar a árvore inteira ao abrir.
 */
import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

/** Define o estado aberto/fechado (no-op se já estiver no estado pedido). */
export function setGlobalSearchOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  emit();
}

/** Alterna aberto/fechado lendo o estado atual (sem stale closure). */
export function toggleGlobalSearch(): void {
  setGlobalSearchOpen(!open);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return open;
}

/** Hook reativo: re-renderiza o assinante quando o palette abre/fecha. */
export function useGlobalSearchOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
